import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import ClassificationType from '../entities/classificationType'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface ClassificationTypeState extends ListState<ClassificationType>{
    editClassificationType:ClassificationType;
    permissions:Array<string>
}
class ClassificationTypeModule extends ListModule<ClassificationTypeState,any,ClassificationType>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<ClassificationType>(),
        loading:false,
        editClassificationType:new ClassificationType()
    }
    actions={
        async getAll(context:ActionContext<ClassificationTypeState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ClassificationType/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<ClassificationType>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<ClassificationTypeState,any>,payload:any){
            await Ajax.post('/api/services/app/ClassificationType/Create',payload.data);
        },
        async update(context:ActionContext<ClassificationTypeState,any>,payload:any){
            await Ajax.put('/api/services/app/ClassificationType/Update',payload.data);
        },
        async delete(context:ActionContext<ClassificationTypeState,any>,payload:any){
            await Ajax.delete('/api/services/app/ClassificationType/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ClassificationTypeState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ClassificationType/Get?Id='+payload.id);
            return reponse.data.result as ClassificationType;
        }
    };
    mutations={
        setCurrentPage(state:ClassificationTypeState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ClassificationTypeState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:ClassificationTypeState,classificationType:ClassificationType){
            state.editClassificationType=classificationType;
        }
    }
}
const classificationTypeModule=new ClassificationTypeModule();
export default classificationTypeModule;